import { uniq, compact } from 'lodash';
import { useFetch } from '@cordata/buffet';
import transformOption from '~/utils/transform/option';
import { ruby } from '~/utils/core/factories';

const serializeOne = v => ({
  data: {
    type: 'care-givers',
    attributes: {
      ...v,
      roles: uniq(compact([
        ...(v.roles || []),
        ...(v.otherRoles?.split(',') || []).map(r => r.trim()),
      ])).join(','),
      relationship: v.relationship ? v.relationship.value : undefined,
    },
    relationships: {
      patient: {
        data: {
          type: 'patients',
          id: v.patient.id,
        },
      },
    },
  },
});

const normalizeOne = v => ({
  ...v,
  roles: v?.roles?.split(','),
});

const fetchAll = (options = {}) =>
  // surprised this works since it fails lint
  (options.patient
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    ? useFetch(`/patients/${options.patient.id || options.patient}/care-givers`)
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    : useFetch('care-givers'));

const fetchOne = (id, options = {}) =>
  // surprised this works since it fails lint
  (options.patient
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    ? useFetch(`/patients/${options.patient.id || options.patient}/care-givers/${id}`)
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    : useFetch(`care-givers/${id}`, options));

const relationships = [
  'Spouse',
  'Child',
  'Relative',
  'Caregiver',
  'Legal Guardian',
  'Partner',
  'Parent',
  'Sibling',
  'Friend',
  'Unknown',
  'Other - Third-Party',
].map(transformOption);

const phoneTypes = [
  'N/A',
  'Home',
  'Mobile',
].map(transformOption);

const roles = [
  'Transportation',
  'Pick up meds',
  'Meals',
  'Counseling services',
  'Case management',
  'Basic hygiene',
  'Monitor vitals',
  'Authorized Contact',
  'Interpreter',
  'Emergency Contact',
  'Next of Kin',
  'Other',
];

const support = {
  relationships,
  phoneTypes,
  roles,
};

const store = {
  fetchAll,
  fetchOne,

  ...ruby('/patients/[patient_uid]/care-givers', { normalizeOne, serializeOne }),

  support,
};

export { store };
